import GetAwsRegions from '../queries/cloud/GetAwsRegionsQuery';
import {AwsRegion} from '../autogenerated/ZoomBridge';
import GetCloudCredentialsForTransfer from '../queries/upload/GetCloudCredentialsForTransfer';
import { GetCloudCredentialsForTransferResponse } from '../autogenerated/ZoomBridge';

export default class S3Util {
  static getS3Regions = function(callBack) {
    new GetAwsRegions().run().then(
      (response: Array<AwsRegion>) => {
        const regions = parseS3Region(response);
        callBack(null, regions);
      },
      (errorId: ErrorId) => {
        console.log('Error', errorId);
        callBack(null, []);
      }
    );
  };

  static getCloudCredentialsForTransfer =  function(callBack){
    new GetCloudCredentialsForTransfer().run().then(
      (response: GetCloudCredentialsForTransferResponse) => {
        callBack(null, response);
      },
      (errorId: ErrorId) => {
        console.info('Error', errorId)
        callBack(ErrorId, null);
      }
    );
  }
}

function parseS3Region(response: Array<AwsRegion>) {
  const regions = new Array();
  response.forEach((region: AwsRegion) => {
    regions.push({label: region.description + ' - ' + region.name, value: region.name});
  });
  return regions;
}
